import { useEffect, useState } from "react";
import ButtonMenu from "src/components/StoryBible/ButtonMenu";
import HoverTippable from "src/components/StoryBible/HoverTippable";
import { useSudowriteStore } from "src/stores/sudowriteStore";
import { UNLIMITED_EXPERIMENT_VARIATIONS } from "../../../../../../src/shared/constants.js";
import TryUnlimitedAndTryMuseTooltip from "../../../MultiUseTooltip/TryUnlimitedAndTryMuseTooltip/index.tsx";

function ProseModeSelectorButton({ proseMode, PROSE_MODES, sceneId, setScenes, disabled = false, scene }) {
  // Unlimited Sudowrite Experiment
  const isInUnlimitedExperiment = useSudowriteStore((state) => state.isInUnlimitedExperiment);
  const unlimitedExperimentVariation = useSudowriteStore((state) => state.unlimitedExperimentVariation);
  const userData = useSudowriteStore((state) => state.userData);
  const [showTryUnlimitedTooltip, setShowTryUnlimitedTooltip] = useState(false);
  const [showTryMuseTooltip, setShowTryMuseTooltip] = useState(false);
  const [usedDraftCount, setUsedDraftCount] = useState(() => {
    return parseInt(localStorage.getItem("unlimited-sudowrite-experiment-used-draft"), 10) || 0;
  });

  useEffect(() => {
    if (usedDraftCount >= 2 && userData && !userData?.data.hideUnlimitedExperimentDraftTooltip) {
      if (isInUnlimitedExperiment && unlimitedExperimentVariation === UNLIMITED_EXPERIMENT_VARIATIONS.UNLIMITED_DEFAULT) {
        setShowTryMuseTooltip(true);
      } else if (isInUnlimitedExperiment && unlimitedExperimentVariation === UNLIMITED_EXPERIMENT_VARIATIONS.MUSE_DEFAULT) {
        setShowTryUnlimitedTooltip(true);
      }
    }
  }, [usedDraftCount, userData, isInUnlimitedExperiment, unlimitedExperimentVariation]);

  return (
    <HoverTippable
      submenuActive={true}
      id="button-container-prose-mode"
    >
      <TryUnlimitedAndTryMuseTooltip
        showTryUnlimitedTooltip={showTryUnlimitedTooltip}
        showTryMuseTooltip={showTryMuseTooltip}
        onTryUnlimitedClosed={() => {
          userData?.update({ hideUnlimitedExperimentDraftTooltip: true });
          setShowTryUnlimitedTooltip(false);
        }}
        onTryMuseClosed={() => {
          userData?.update({ hideUnlimitedExperimentDraftTooltip: true });
          setShowTryMuseTooltip(false);
        }}
        defaultTooltipContent={null}
        defaultTooltipDisabled={true}
        showAllArrows={true}
        tryMuseArrowOffset={64}
        tryUnlimitedArrowOffset={64}
      >
        <ButtonMenu
          id="button-prose-mode-selector"
          disabled={disabled}
          onClick={(val) => {
            if (setScenes) {
              setScenes((draft) => {
                const targetSceneId = sceneId || scene?.id;
                if (!targetSceneId || !draft[targetSceneId]) {
                  return;
                }
                draft[targetSceneId].proseMode = val;
              });
            }
          }}
          selectOnly={true}
          useModelSelectionModal={true}
          supportsBenchmarkMode={true}
          proseMode={proseMode.label === "Basic" && isInUnlimitedExperiment ? { ...proseMode, label: "Unlimited" } : proseMode}
          proseModes={PROSE_MODES}
          generateProse={() => {}}
          generateLabel="Prose Mode"
        />
      </TryUnlimitedAndTryMuseTooltip>
    </HoverTippable>
  );
}

export default ProseModeSelectorButton;
